import { render } from "./PretList.vue?vue&type=template&id=4c7e7949"
import script from "./PretList.vue?vue&type=script&lang=js"
export * from "./PretList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__